import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexte/AuthContexte';

export default function Inscription() {
  const navigate = useNavigate();
  const { inscription } = useAuth();
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);

  async function soumettre(e) {
    e.preventDefault();
    setErreur('');
    setLoading(true);
    try {
      await inscription({ nom, email, mot_de_passe: motDePasse });
      navigate('/');
    } catch (e2) {
      setErreur(e2?.response?.data?.message || 'Inscription impossible');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-lg rounded-3xl border border-gray-200 bg-white p-6 md:p-8">
      <div className="text-xs font-semibold uppercase tracking-widest text-gray-600">Compte</div>
      <div className="mt-2 text-2xl font-bold text-gray-900">Inscription</div>

      {erreur ? (
        <div className="mt-4 rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">{erreur}</div>
      ) : null}

      <form onSubmit={soumettre} className="mt-6 grid gap-4">
        <input
          value={nom}
          onChange={(e) => setNom(e.target.value)}
          placeholder="Nom"
          className="w-full rounded-2xl border border-gray-200 bg-gray-50 px-5 py-4 text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none"
        />
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          placeholder="Email"
          className="w-full rounded-2xl border border-gray-200 bg-gray-50 px-5 py-4 text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none"
        />
        <input
          value={motDePasse}
          onChange={(e) => setMotDePasse(e.target.value)}
          type="password"
          placeholder="Mot de passe"
          className="w-full rounded-2xl border border-gray-200 bg-gray-50 px-5 py-4 text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none"
        />

        <button
          disabled={loading}
          className="rounded-2xl bg-marega-600 px-5 py-4 text-sm font-semibold text-white shadow-lg shadow-marega-600/20 hover:bg-marega-500 disabled:opacity-50"
        >
          {loading ? 'Création...' : 'Créer mon compte'}
        </button>
      </form>

      <div className="mt-6 text-sm text-gray-600">
        Déjà un compte ?{' '}
        <Link to="/connexion" className="text-marega-700 hover:text-marega-800">
          Connexion
        </Link>
      </div>
    </div>
  );
}
